<template>
    <app-alert-mguu />
    <div class="mguu-title">Мои тесты</div>
    <div class="mguu-plans-container">
        <span
            :class="`mguu-plans-tab__${tabs_style[index]}`"
            @click="refreshTests(val.status, index)"
            v-for="(val, index) in rowsMG.titles"
            :key="index"
        >
            {{ val.title }}
            <span :class="`mguu-plans-tab__${tabs_style[index]}__count`">
                {{ getCountTests(val.status) }}</span
            >
        </span>
    </div>
    <testPlanRow
        :tests="rowsMG.currentTestsMG"
        :showMsg="rowsMG.currentTestsMG?.length != 0"
        :loading="isLoading"
    />
</template>

<script>
import testPlanRow from '@/components/workspace/assessmentPlans/plans/plan/test/row/mguu.vue';
import AppAlertMguu from '@/components/UI/AppAlert/AppAlertMguu.vue';
import useAlertMguuStore from '@/store/alertmguu.store.ts';
import { mapActions, mapGetters, mapState } from 'vuex';

export default {
    name: 'planMG',
    components: { testPlanRow, AppAlertMguu },
    data() {
        const statuses = ['all', 'new', 'completed'];
        const activeIndex = Math.max(
            statuses.indexOf(this.$route.query.tab),
            0,
        );
        const tabs_style = ['none', 'none', 'none'];
        tabs_style[activeIndex] = 'selected';
        return {
            notFound: false,
            tabs_style,
            //showAlertMguu: false,
            textMessage: '',
        };
    },
    setup() {
        const alertMguuStore = useAlertMguuStore();

        return {
            alertMguuStore,
        };
    },

    computed: {
        ...mapGetters('assessmentPlans/plan', ['rowsMG']),
        ...mapState('assessmentPlans/plan', ['isLoading']),
    },
    methods: {
        ...mapActions('assessmentPlans/plan', ['fetchPlanMG']),

        getPlan() {
            const status = this.$route.query.tab ?? 'all';
            this.fetchPlanMG({ status })
                .catch(({}) => {
                    this.alertMguuStore.showAlertMguuTextMessage =
                        'Не удалось загрузить данные';
                    this.alertMguuStore.isShowAlertMguu = true;
                })
                .finally(() => {});
        },
        refreshTests(status, index) {
            this.tabs_style.fill('none');
            this.tabs_style[index] = 'selected';
            this.$router.replace({
                query: { ...this.$route.query, tab: status },
            });
            this.$store.commit(
                'assessmentPlans/plan/filteredAssessmentPlanMGUU',
                status,
            );
        },
        getCountTests(status) {
            switch (status) {
                case 'new':
                    return this.rowsMG.countNew;
                case 'completed':
                    return this.rowsMG.countCompleted;
                default:
                    return this.rowsMG.countAll;
            }
        },
    },

    mounted() {
        this.getPlan();
    },
};
</script>

<style lang="scss">
.mguu-title {
    font-size: 40px;
    font-weight: 600;
    line-height: 48px;
    margin-bottom: 16px;
}

.mguu-plans-container {
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 24px;
    box-sizing: border-box;
    border-bottom: 1px solid #e6e6e6; 
    width: max-content;
}

@media (mac-width: 768px) {
  .mguu-plans-container {
    gap: 16px;
  }
}

.mguu-plans-tab__none {
    display: flex;
    align-items: center;
    gap: 12px;
    cursor: pointer;
    color: #8E8E9D;
    font-weight: 500;
    padding: 10px 0;
    border-bottom: 2px solid transparent;
    margin-bottom: -1px;

    &__count {
        color: #8E8E9D;
        font-weight: 400;
    }

    @media (max-width: 768px) {
      &__count {
        display: none;
      }
    }
}

.mguu-plans-tab__selected {
    display: flex;
    align-items: center;
    gap: 12px;
    cursor: pointer;
    color: #12122C;
    font-weight: 500;
    padding: 10px 0;
    border-bottom: 2px solid #12122C;
    margin-bottom: -1px;

    &__count {
        display: flex;
        align-items: center;
        justify-content: center;
        min-width: 24px;
        height: 24px;
        padding: 0 12px;
        border-radius: 80px;
        color: #ffffff;
        background-color: #1F1D4B;
        font-size: 14px; 
        font-weight: 400;
    }
}
</style>
